import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "label", "dropdown", "customInput"]
  static values = {
    category: String,
    current: { type: Number, default: 1 }
  }

  connect() {
    this.handleClickOutside = this.handleClickOutside.bind(this)
    document.addEventListener('click', this.handleClickOutside)
  }

  disconnect() {
    document.removeEventListener('click', this.handleClickOutside)
  }

  toggle(event) {
    event.stopPropagation()
    this.dropdownTarget.classList.toggle('hidden')
  }

  handleClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.dropdownTarget.classList.add('hidden')
    }
  }

  select(event) {
    const days = event.currentTarget.dataset.days
    const hours = event.currentTarget.dataset.hours
    if (hours) {
      this.navigateToHours(hours)
    } else {
      this.navigateToRange(days)
    }
  }

  applyCustom() {
    const days = this.customInputTarget.value
    if (days && days >= 1 && days <= 1095) {
      this.navigateToRange(days)
    }
  }

  selectYear(event) {
    const year = event.currentTarget.dataset.year
    this.navigateToYear(year)
  }

  navigateToRange(days) {
    const url = new URL(window.location.href)
    url.searchParams.set("days", days)
    url.searchParams.delete("hours")
    url.searchParams.delete("year")
    window.location.href = url.toString()
  }

  navigateToHours(hours) {
    const url = new URL(window.location.href)
    url.searchParams.set("hours", hours)
    url.searchParams.delete("days")
    url.searchParams.delete("year")
    window.location.href = url.toString()
  }

  navigateToYear(year) {
    const url = new URL(window.location.href)
    url.searchParams.set("year", year)
    url.searchParams.delete("days")
    window.location.href = url.toString()
  }

  formatLabel(days) {
    days = parseInt(days)
    if (days === 1) return "24時間"
    if (days <= 6) return `${days}日間`
    if (days === 7) return "1週間"
    if (days <= 13) return `${days}日間`
    if (days === 14) return "2週間"
    if (days <= 29) return `${days}日間`
    if (days <= 59) return "1ヶ月"
    if (days <= 89) return "2ヶ月"
    if (days <= 119) return "3ヶ月"
    if (days <= 149) return "4ヶ月"
    if (days <= 179) return "5ヶ月"
    if (days <= 269) return "6ヶ月"
    if (days <= 364) return "9ヶ月"
    if (days <= 729) return "1年"
    if (days <= 1094) return "2年"
    return "3年以上"
  }
}
